var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "material-price"
  }, _vm._l(_vm.materialPurchaseList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "material-item",
      attrs: {
        "value": index
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.material.name))]), _c('Input', {
      staticStyle: {
        "width": "80px"
      },
      model: {
        value: item.calcPurchaseUnitCost,
        callback: function ($$v) {
          _vm.$set(item, "calcPurchaseUnitCost", $$v);
        },
        expression: "item.calcPurchaseUnitCost"
      }
    })], 1);
  }), 0), _c('div', {
    staticClass: "semiItem-wrap"
  }, [_vm._l(_vm.cardList, function (card, index) {
    return _c('div', {
      key: card,
      staticClass: "semiItem-card"
    }, [_c('SemiContrastCard', {
      ref: "SemiContrastCard",
      refInFor: true,
      attrs: {
        "index": index,
        "materialPurchaseList": _vm.materialPurchaseList
      },
      on: {
        "changeSemi": _vm.changeSemi,
        "closeCard": _vm.closeCard
      }
    })], 1);
  }), _c('div', {
    staticClass: "addCard"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-add",
      "size": "100",
      "color": "#88D1F1"
    },
    on: {
      "click": _vm.addCard
    }
  })], 1)], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }